import React from "react";
import { useShow } from "@refinedev/core";
import { DateField } from "@refinedev/antd";
import { Tag, Spin } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import {
    BankOutlined,
    EditOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    PhoneOutlined,
    MailOutlined,
    EnvironmentOutlined,
} from "@ant-design/icons";
import { PageHeader } from "../../components/ui";

export const BranchShow = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { queryResult } = useShow({
        resource: "branch",
        id,
        meta: {
            fields: [
                "id",
                "name",
                "address",
                "phoneNumber",
                "email",
                "isActive",
                "createdAt",
                "updatedAt"
            ],
        }
    });

    const { data, isLoading } = queryResult;
    const record = data?.data;

    if (isLoading) {
        return (
            <div className="page-container flex items-center justify-center" style={{ minHeight: 400 }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div className="page-container">
            <PageHeader
                title={record?.name || "Branch Details"}
                titleIcon={<BankOutlined />}
                breadcrumbs={[
                    { title: "Branches", href: "/branch" },
                    { title: record?.name || "Details" },
                ]}
                actions={[
                    {
                        label: "Edit",
                        onClick: () => navigate(`/branch/edit/${id}`),
                        type: "primary",
                        icon: <EditOutlined />,
                    },
                ]}
            >
                {/* Mini Stat Cards */}
                <div className="mini-stat-cards-row">
                    <div className="mini-stat-card">
                        <div className="mini-stat-label">Branch Name</div>
                        <div className="mini-stat-value">{record?.name || "-"}</div>
                    </div>
                    <div className="mini-stat-card">
                        <div className="mini-stat-label">Status</div>
                        <div className={`status-badge ${record?.isActive ? 'active' : 'inactive'}`}>
                            {record?.isActive ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                            {record?.isActive ? "Active" : "Inactive"}
                        </div>
                    </div>
                </div>
            </PageHeader>

            <div className="space-y-4">
                {/* Branch Information Card */}
                <div className="info-card">
                    <div className="info-card-header">
                        <h3 className="info-card-title">Branch Information</h3>
                    </div>
                    <div className="info-card-body">
                        <div className="info-grid">
                            <div className="info-item">
                                <span className="info-label">
                                    <BankOutlined style={{ marginRight: 8 }} />
                                    Branch Name:
                                </span>
                                <span className="info-value font-semibold">{record?.name || "-"}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">
                                    <PhoneOutlined style={{ marginRight: 8 }} />
                                    Phone:
                                </span>
                                <span className="info-value">{record?.phoneNumber || "-"}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">
                                    <MailOutlined style={{ marginRight: 8 }} />
                                    Email:
                                </span>
                                <span className="info-value">{record?.email || "-"}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Status:</span>
                                <Tag color={record?.isActive ? "success" : "default"}>
                                    {record?.isActive ? "Active" : "Inactive"}
                                </Tag>
                            </div>
                            <div className="info-item full-width">
                                <span className="info-label">
                                    <EnvironmentOutlined style={{ marginRight: 8 }} />
                                    Address:
                                </span>
                                <span className="info-value">{record?.address || "-"}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Created At:</span>
                                <span className="info-value">
                                    <DateField value={record?.createdAt} format="YYYY-MM-DD HH:mm:ss" />
                                </span>
                            </div>
                            {record?.updatedAt && (
                                <div className="info-item">
                                    <span className="info-label">Last Updated:</span>
                                    <span className="info-value">
                                        <DateField value={record.updatedAt} format="YYYY-MM-DD HH:mm:ss" />
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
